export default __webpack_public_path__ + "static/media/ic_expert_active.ed71b21e.svg";